import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroCarousel from '../../components/home/HeroCarousel';
import AnimationShowcase from '../../components/home/AnimationShowcase';
import ProductGrid from '../../components/home/ProductGrid';
import FeatureSection from '../../components/home/FeatureSection';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Shreepati · Luxury, Without the occasion. Crafted to Shine Everyday 💅</title>
        <meta name="description" content="Découvrez notre collection de sarees et bijoux indiens d'exception" />
      </Helmet>
      
      <HeroCarousel />
      <AnimationShowcase />
      <ProductGrid />
      <FeatureSection />
    </>
  );
};

export default HomePage;